import { ApplicationTypes, attachComponent } from 'awr-domain'

import { memoEval, propertyPageComponent, sceneEntityObjectComponent } from '@salsita-ai/platform-project-sdk/domain'
import {
  AttributeSwitchSelector,
  DistanceDimensionInput,
  GenericDimensionInput,
} from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { createExtrudedStairsObject, createStairsSketchingObject } from '../canvas/stairs.js'

export const stairsComponents = [
  attachComponent
    .withEntity('Stairs')
    .withComponent(sceneEntityObjectComponent, 'main')
    .withGradualFilter({ viewStates: [ApplicationTypes.ViewState['3dView']] })
    .attach(
      memoEval(
        s => [s.width, s.numberOfSteps, s.riserDistance, s.goingDistance, s.balustradeLeft, s.balustradeRight],
        (width, numberOfSteps, riserDistance, goingDistance, leftBalustrade, rightBalustrade) => {
          return {
            object: createExtrudedStairsObject({
              width,
              numberOfSteps,
              riserDistance,
              goingDistance,
              leftBalustrade,
              rightBalustrade,
            }),
          }
        }
      )
    ),
  attachComponent
    .withEntity('Stairs')
    .withComponent(sceneEntityObjectComponent, 'mainFloorPlan')
    .withGradualFilter({
      viewStates: [ApplicationTypes.ViewState.FloorPlan],
      navigationStates: [ApplicationTypes.NavigationState.Properties, ApplicationTypes.NavigationState.Summary],
    })
    .attach(
      memoEval(
        s => [s.width, s.numberOfSteps, s.riserDistance, s.goingDistance, s.balustradeLeft, s.balustradeRight],
        (width, numberOfSteps, riserDistance, goingDistance, leftBalustrade, rightBalustrade) => {
          return {
            object: createExtrudedStairsObject({
              width,
              numberOfSteps,
              riserDistance,
              goingDistance,
              leftBalustrade,
              rightBalustrade,
            }),
          }
        }
      )
    ),

  attachComponent
    .withEntity('Stairs')
    .withComponent(sceneEntityObjectComponent, 'sketching')
    .withGradualFilter({
      viewStates: [ApplicationTypes.ViewState.FloorPlan],
      navigationStates: [ApplicationTypes.NavigationState.Build],
    })
    .attach(
      memoEval(
        s => [s.width, s.numberOfSteps, s.riserDistance, s.goingDistance, s.balustradeLeft, s.balustradeRight],
        (width, numberOfSteps, riserDistance, goingDistance, leftBalustrade, rightBalustrade) => {
          return {
            object: createStairsSketchingObject({
              width,
              numberOfSteps,
              riserDistance,
              goingDistance,
              leftBalustrade,
              rightBalustrade,
            }),
          }
        }
      )
    ),

  attachComponent
    .withEntity('Stairs')
    .withComponent(propertyPageComponent, 'main')
    .attach(
      memoEval(
        s => [s.id],
        id => ({
          page: (
            <>
              <PropertyContainer.Group spacing="large">
                <PropertyContainer.Item>
                  <AttributeSwitchSelector
                    entityId={id}
                    instanceName="balustradeLeft"
                    title="Balustrade"
                    description="Left side"
                  />
                </PropertyContainer.Item>
                <PropertyContainer.Item>
                  <AttributeSwitchSelector
                    entityId={id}
                    instanceName="balustradeRight"
                    title="Balustrade"
                    description="Right side"
                  />
                </PropertyContainer.Item>
                <PropertyContainer.Item title="Number of steps" description="Total number of steps in the step block">
                  <GenericDimensionInput entityId={id} instanceName="numberOfSteps" />
                </PropertyContainer.Item>
                <PropertyContainer.Item
                  title="Going distance"
                  description="Distance between the front and back of the step block"
                >
                  <DistanceDimensionInput entityId={id} instanceName="goingDistance" />
                </PropertyContainer.Item>
                <PropertyContainer.Item title="Riser distance" description="Height of each individual step.">
                  <DistanceDimensionInput entityId={id} instanceName="riser" />
                </PropertyContainer.Item>
              </PropertyContainer.Group>
            </>
          ),
        })
      )
    ),
]
